import React from "react";
import { Paper, Typography } from "@mui/material";
import MuiBarChart from "./MuiBarChart.tsx";

const RegionalPerformanceChart = () => {
  const regions = ["North", "South", "East", "West"];
  const performance = [
    { data: [120, 100, 90, 110], label: "Leads", color: "#3e59e3" },
    { data: [40, 50, 30, 45], label: "Conversions", color: "#4caf50" },
  ];

  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>Regional Performance</Typography>
      <MuiBarChart xLabels={regions} series={performance} />
    </Paper>
  );
};

export default RegionalPerformanceChart;